<template>
  <v-data-table :items="getCustomers" :headers="getHeaders" :search="search">
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <v-btn icon text @click="editCustomer(item)">
          <v-icon>fa-edit</v-icon>
        </v-btn>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CustomerGrid",
  computed: {
    ...mapGetters(["getCustomers", "getIsAdmin"]),
    getHeaders() {
      if (this.getIsAdmin) {
        return [
          { value: "nom", text: "Client" },
          { value: "actions", text: "" }
        ];
      } else {
        return [{ value: "nom", text: "Client" }];
      }
    }
  },
  data() {
    return {
      search: ""
    };
  },
  methods: {
    editCustomer(item) {
      this.$router.push({
        name: "CustomerEditor",
        params: { id: item.id_client }
      });
    }
  }
};
</script>

<style></style>
